/* PDP store availablility sheet */
'use strict';

import { queryFirst, queryAll, addClass, removeClass, removeAttribute, setAttribute, toFormData } from '../domUtil';
import { getJSON, geolocate, setItemInLocalStorage, getItemFromLocalStorage } from '../util';
import { includeGoogleMaps, getLatLong } from '../googleMaps';
import { PREFERRED_STORE_ID, HIDDEN_CLASS, ACTIVE_CLASS, NOT_AVAILABLE_CLASS } from '../constants';
import { updateCartTotals, updatePromoCodeDetails, validateBasket, updateCartItems } from '../cart/cart';
import { toggleLocationIcon } from './pickUpInStore/ispuHelper';
import { SPU_HIDDEN_CLASS } from './shippingPreference/constants';
import { updateVisibilityOfLowInventoryMsg } from './shippingPreference/shippingPreferenceHelper';

const $body = $('body');
const hiddenClass = 'd-none';
let ispuContainer = queryFirst('.sheet-page.pickup-in-store-content .pickup-in-store-container');
let ispuModalContainer = $('.sheet.modal[id*="pick-up-in-store"]');
const pickUpInStoreButton = queryFirst('.btn-in-store-pickup');
const isRecognizedUser = pickUpInStoreButton && pickUpInStoreButton.dataset.isRecognizedUser === 'true';
const ispuClosestParent = $('.product-detail, .cart-page');
let targetModal = null;
let currentTargetIspuButton = null;

/**
 * Toggle sheet view
 * @param {*} sheet
 */
function showSheet(sheetSelector, id) {
    if (id) {
        addClass(queryAll('.sheet-page.pickup-in-store-content'), HIDDEN_CLASS);
        removeClass(queryAll('.sheet-page.pickup-in-store-content'), ACTIVE_CLASS);
    }

    const activeIspuModal = ispuModalContainer.filter(id ? `[id$=${id}]` : ':has(.active)')[0];
    const sheetContent = queryFirst('.sheet-page' + sheetSelector, activeIspuModal);

    removeClass(sheetContent, HIDDEN_CLASS);
    addClass(sheetContent, ACTIVE_CLASS);
}
/**
 * This method checks if the user is on cart page
 * @returns {boolean} is cart page or not
 */
function isInCartPage() {
    const cartPage = queryFirst('.cart-page');
    return !!cartPage;
}

/**
 * This method checks if the user is on PDP page
 * @returns {boolean} is PDP page or not
 */
function isInPdpPage() {
    const pdpPage = queryFirst('.pdp-container');
    return !!pdpPage;
}

/**
 * This method returns ISPU cart line items details
 * @returns {Object} ISPU cart line items details
 */
function getIspuCartLineItemDetails() {
    const ispuContainer = queryFirst('.cart-page .cart-products-ispu');
    const ispuLineItems = queryAll('.cart-product-line-item', ispuContainer);
    let ispuLineItemsData = [];
    if (ispuLineItems) {
        ispuLineItems.forEach(ispuLineItem => {
            const { pid, uuid } = ispuLineItem.dataset;
            const quantity = queryFirst('.quantity', ispuLineItem).value;
            ispuLineItemsData.push({
                pid,
                uuid,
                quantity
            });
        });
    }
    return ispuLineItemsData;
}

/**
 * This method handles the store results content
 * @param {Object} data store results
 */
function handleStoreResults(data) {
    // showSheet should be called before finding the active ISPU modal container
    showSheet('.pickup-in-store-content');
    const activeIspuModalContainer = ispuModalContainer.filter(':has(.active)');
    const closestIspuContainer = activeIspuModalContainer.find('.sheet-page.pickup-in-store-content .pickup-in-store-container')[0];
    const noStoresMessage = queryFirst('.store-locator-no-results', closestIspuContainer);
    const findStoresForm = queryFirst('.find-stores-form', closestIspuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', closestIspuContainer);
    const productDetails = queryFirst('.pickup-in-store-product', closestIspuContainer);
    const pickupAddToCartBlock = queryFirst('.js-sp-add-to-cart', closestIspuContainer.closest('.pickup-in-store-modal'));
    const pickupAddToCartSelector = isInCartPage() ? '.store-confirm-button' : '.add-to-cart';
    const pickupAddToCartEl = queryFirst(pickupAddToCartSelector, pickupAddToCartBlock);
    const selectedStoreInput = queryFirst('.select-store-input:checked:not([disabled])', closestIspuContainer);
    const sizeList = queryFirst('.size-container', productDetails);
    addClass(queryFirst('.geo-location-error', closestIspuContainer), hiddenClass);

    if (pickupAddToCartEl && !selectedStoreInput) {
        pickupAddToCartEl.disabled = true;
    }

    if (data.storesResultsHtml) {
        storeResults.innerHTML = data.storesResultsHtml;
        noStoresMessage.textContent = '';
        if (!data.isCartPage) {
            removeClass(productDetails, hiddenClass);
        }
        removeClass(storeResults, hiddenClass);
        addClass(noStoresMessage, hiddenClass);
        addClass(findStoresForm, hiddenClass);
        removeClass(pickupAddToCartEl, SPU_HIDDEN_CLASS);
        removeClass(pickupAddToCartBlock, hiddenClass);

        const selectStoreInput = queryAll('.select-store-input');

        let selectedStoreId = null;
        const savedStoreId = window.lillyUtils.shippingPreferencesConfig.storeId;

        if ((isInCartPage() || savedStoreId === 'null' || !savedStoreId) && data.preferredStore) {
            setItemInLocalStorage(PREFERRED_STORE_ID, data.preferredStore.ID);
            selectedStoreId = data.preferredStore.ID;
        } else {
            selectedStoreId = savedStoreId;
        }

        if (sizeList) {
            const { stores } = data;
            if (stores) {
                const sizeBtns = queryAll('.size-btn', productDetails);

                sizeBtns.forEach(btn => {
                    const { variationId: sku } = btn.dataset;
                    let hasStock = false;
                    let selectedStoreDetails = null;
                    if (selectedStoreId && savedStoreId !== 'null') {
                        // If prefered store is set and selected store is same as prefered store
                        // then show size availability based on prefered store
                        // else find selected store in store search results
                        if (data.preferredStore && data.preferredStore.ID === selectedStoreId) {
                            selectedStoreDetails = data.preferredStore;
                        } else {
                            selectedStoreDetails = stores.find(store => store.ID === selectedStoreId) || null;
                        }
                    }
                    // If selected store details are available
                    // check stock for the sku in selected store
                    // else check stock across all stores in search results
                    if (selectedStoreDetails) {
                        hasStock = selectedStoreDetails.allVariantsInventory?.some(record => record.id === sku && parseInt(record.quantity, 10) > 0) ?? false;
                    } else {
                        hasStock = stores?.some(store => !!parseInt(store.allVariantsInventory?.find(record => record.id === sku)?.quantity, 10)) ?? true;
                    }
                    if (hasStock) removeClass(btn, NOT_AVAILABLE_CLASS);
                    else addClass(btn, NOT_AVAILABLE_CLASS);
                });
            }
        }

        if (selectedStoreId) {
            removeAttribute(selectStoreInput, 'checked');
            const selectedStoreInput = queryFirst(`.select-store-input[data-store-id*="${selectedStoreId}"]:not([disabled])`);
            const selectedSizeInput = queryFirst('.size-btn.selected');
            setAttribute(selectedStoreInput, 'checked', true);
            removeClass(pickupAddToCartBlock, hiddenClass);

            if (pickupAddToCartEl) {
                if (selectedStoreInput && (isInCartPage() || selectedSizeInput)) {
                    pickupAddToCartEl.disabled = false;
                    removeClass(pickupAddToCartEl, SPU_HIDDEN_CLASS);
                } else {
                    pickupAddToCartEl.disabled = true;
                }
            }
            if (!isInCartPage() && selectedStoreInput && selectedSizeInput) {
                const { variationid } = selectedSizeInput.dataset;
                updateVisibilityOfLowInventoryMsg(ispuClosestParent[0], variationid);
            }
        }
    } else if (data.noStoresErrorMessage) {
        noStoresMessage.innerHTML = data.noStoresErrorMessage;
        addClass([storeResults, pickupAddToCartBlock], hiddenClass);
        removeClass(noStoresMessage, hiddenClass);
        removeClass(findStoresForm, hiddenClass);
    } else {
        removeClass(pickupAddToCartEl, SPU_HIDDEN_CLASS);
    }

    ispuModalContainer.find('.sheet-dialog').spinner().stop();
}

/**
 * This method handles the store confirmation results content
 * @param {Object} data store results
 */
function handleConfirmStoreResults(data) {
    const storeConfirm = queryFirst('.pick-up-confirm-section', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    const storeForm = queryFirst('.find-stores-form', ispuContainer);
    storeConfirm.innerHTML = data.storesResultsHtml;
    if (data.storesResultsHtml) {
        removeClass(storeConfirm, hiddenClass);
        addClass([storeResults, storeForm], hiddenClass);
    }
    ispuModalContainer.find('.sheet-dialog').spinner().stop();
}

/**
 * This method is an error handler of ajax call
 */
function errorCallBack() {
    ispuModalContainer.find('.sheet-dialog').spinner().stop();
}

$body.on('product:pdpSizeSelected', ($event, data) => {
    const { target } = $event;
    const { productContainer } = data;

    if (ispuModalContainer.is(':visible')) {
        const { actionUrl, pid, googleKey, productName, swatchName, masterId } = currentTargetIspuButton?.dataset ?? {};

        const isCartPage = isInCartPage();
        const ispuContainerDataset = ispuContainer.dataset;
        const mixinData = {
            products: pid,
            isCartPage
        };

        includeGoogleMaps(googleKey);

        ispuContainerDataset.pid = pid;
        ispuContainerDataset.productName = productName;
        ispuContainerDataset.swatchName = swatchName;
        ispuContainerDataset.masterId = masterId;

        if (isRecognizedUser) {
            const storeId = getItemFromLocalStorage(PREFERRED_STORE_ID);

            if (storeId) {
                mixinData.storeID = storeId;
            }
        }
        const searchStoreResultTitle = queryFirst('.search-store-toggle', ispuContainer);
        if (searchStoreResultTitle) {
            mixinData.searchStoreResultTitle = searchStoreResultTitle.textContent.trim();
        }

        if (ispuContainerDataset.selectStoreView === 'true') {
            mixinData.selectStoreView = true;
        }
        if (isCartPage) {
            const quantity = queryFirst('.quantity', target.closest('.cart-product-line-item')).value;
            mixinData.quantity = quantity;
            const { uuid } = target.dataset;
            ispuContainerDataset.uuid = uuid;
            ispuContainerDataset.quantity = quantity;
            addClass(queryFirst('.pickup-in-store-product'), HIDDEN_CLASS);
        }

        targetModal = queryFirst('.sheet.modal[id*="pick-up-in-store"]');
        const address = queryAll('.find-store-input', targetModal)[1].value;

        if (address) {
            getLatLong(handleInStore, { address, actionUrl });
        } else {
            geolocate(
                data => {
                    ispuModalContainer.find('.sheet-dialog').spinner().start();
                    toggleLocationIcon(true, ispuContainer);
                    getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
                },
                mixinData,
                data => {
                    toggleLocationIcon(false, ispuContainer);
                    getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
                }
            );
        }
    }
});

// Event listener to retrieve store results on click of Pick up in store in PDP
$('.pdp-in-store-inventory, .cart-page').on('click', '.btn-in-store-pickup', event => {
    const { target } = event;
    const { actionUrl, pid, googleKey, productName, swatchName, masterId, targetid } = target.dataset;
    const isCartPage = isInCartPage();

    const ispuContainerDataset = ispuContainer.dataset;
    const mixinData = {
        products: pid,
        isCartPage
    };
    includeGoogleMaps(googleKey);
    $('.sheet-dialog.pickup-in-store-modal').attr('aria-hidden', false);

    showSheet('.pickup-in-store-content', targetid || pid);

    ispuContainerDataset.pid = pid;
    ispuContainerDataset.productName = productName;
    ispuContainerDataset.swatchName = swatchName;
    ispuContainerDataset.masterId = masterId;
    currentTargetIspuButton = target;
    if (isRecognizedUser) {
        const storeId = getItemFromLocalStorage(PREFERRED_STORE_ID);

        if (storeId) {
            mixinData.storeID = storeId;
        }
    }
    if (ispuContainerDataset.selectStoreView === 'true') {
        mixinData.selectStoreView = true;
    }
    if (isCartPage) {
        const quantity = queryFirst('.quantity', target.closest('.cart-product-line-item')).value;
        mixinData.quantity = quantity;
        const { uuid } = target.dataset;
        ispuContainerDataset.uuid = uuid;
        ispuContainerDataset.quantity = quantity;
        addClass(queryFirst('.pickup-in-store-product'), hiddenClass);
    }
    const targetModal = queryFirst('.sheet.modal[id*="pick-up-in-store"]');
    const address = queryAll('.find-store-input', targetModal)[1].value;

    if (address) {
        getLatLong(handleInStore, { address, actionUrl });
    } else {
        geolocate(
            data => {
                ispuModalContainer.find('.sheet-dialog').spinner().start();
                toggleLocationIcon(true, ispuContainer);
                getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
            },
            mixinData,
            data => {
                toggleLocationIcon(false, ispuContainer);
                getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
            }
        );
    }
});

// Event listener to select a store from ISPU drawer
ispuClosestParent.on('click', '.btn-select-store', event => {
    const { target } = event;
    const { storeId } = target.dataset;
    const productContainer = target.closest('.product-detail');
    // prevent store unselect
    if (!target.checked) {
        event.preventDefault();
        return false;
    }

    const selectStoreInputs = queryAll('.js-select-store-input');
    selectStoreInputs.forEach(function (selectStoreInput) {
        selectStoreInput.checked = false;
    });

    target.checked = true;
    const pickupAddToCartSelector = isInCartPage() ? '.store-confirm-button' : '.add-to-cart';
    const pickupAddToCartEl = queryFirst(pickupAddToCartSelector);
    pickupAddToCartEl.disabled = false;

    $body.trigger('product:updateStoreInventory', { storeId, productContainer });
});

ispuClosestParent.on('click', '.sheet-page .modal-back', () => {
    showSheet('.pickup-in-store-content');

    addClass(queryFirst('.find-stores-form', ispuContainer), HIDDEN_CLASS);
});

ispuClosestParent.on('click', '.search-store-toggle', event => {
    event.preventDefault();
    const { target } = event;
    showSheet('.pickup-in-store-search-form');
    removeClass(queryFirst('.find-stores-form', target.closest('.pickup-in-store-container')), HIDDEN_CLASS);
});
// Event Listener for edit pick up store link in cart page
$('.cart-page').on('click', '.js-edit-store-pickup', event => {
    ispuContainer.dataset.editStore = 'true';
    const products = null;
    const { actionUrl, googleKey } = event.target.dataset;
    includeGoogleMaps(googleKey);
    addClass(queryFirst('.pickup-in-store-product'), hiddenClass);
    const mixinData = {
        products,
        isCartPage: true
    };
    geolocate(
        data => {
            ispuModalContainer.find('.sheet-dialog').spinner().start();
            toggleLocationIcon(true, ispuContainer);
            getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
        },
        mixinData,
        data => {
            toggleLocationIcon(false, ispuContainer);
            getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
        }
    );
});

/**
 * This method retrieves store results based on zipcode, city or state
 * @param {Object} locationData google location data based on input value
 */
function handleInStore(locationData) {
    const { latitude, longitude, address, actionUrl, forceGeoLocation } = locationData;
    const ispuContainerDataset = ispuContainer.dataset;
    const isEditStore = JSON.parse(ispuContainerDataset.editStore || 'false');
    let products = null;
    if (!isEditStore) {
        products = ispuContainerDataset.pid + ':' + ispuContainerDataset.quantity;
    }
    const isCartPage = isInCartPage();
    const data = {
        products,
        latitude,
        longitude,
        inputSearchParameter: address,
        isCartPage,
        forceGeoLocation
    };
    data.selectStoreView = isInPdpPage();
    if (isRecognizedUser) {
        const storeId = getItemFromLocalStorage(PREFERRED_STORE_ID);
        if (storeId) {
            data.storeID = storeId;
        }
    }
    ispuModalContainer.find('.sheet-dialog').spinner().start();
    getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
}

// Event listener to retrieve store results based on input search in pick up in store drawer
ispuClosestParent.on('submit', '.find-stores-form', event => {
    event.preventDefault();
    const { target } = event;
    const actionUrl = target.getAttribute('action');
    const address = queryFirst('.find-store-input', target.closest('.find-stores-form')).value;
    queryAll('.find-store-input').forEach(function (input) {
        input.value = address;
    });
    if (address) {
        targetModal = target.closest('.sheet-page.active.pickup-in-store-container');
        getLatLong(handleInStore, {
            address,
            actionUrl
        });
    }
});

/**
 * This method retrieves store results based on zipcode, city or state after preferred store slection
 * @param {Object} locationData google location data based on input value
 */
function handlePreferredStore(locationData) {
    const url = queryFirst('.preferred-store-input').dataset.actionUrl;
    const isCartPage = isInCartPage();
    const { latitude, longitude, address, storeID, products } = locationData;
    const data = {
        products,
        latitude,
        longitude,
        inputSearchParameter: address,
        storeID,
        isCartPage,
        selectStoreView: isInPdpPage()
    };
    ispuModalContainer.find('.sheet-dialog').spinner().start();
    getJSON(url, 'POST', data, handleStoreResults, errorCallBack);
}

// Event listener to update preferred store and rerender store results
ispuClosestParent.on('click', '.preferred-store-input', event => {
    const { target } = event;
    const isEditStore = JSON.parse(ispuContainer.dataset.editStore);
    let products = null;
    if (!isEditStore) {
        products = ispuContainer.dataset.pid;
    }
    const address = queryFirst('.find-store-input').value;
    const { dataset } = target;
    const { actionUrl, storeId } = dataset;
    const isCartPage = isInCartPage();
    const mixinData = {
        products,
        storeID: storeId,
        isCartPage
    };
    if (isCartPage && !isEditStore) {
        mixinData.quantity = ispuContainer.dataset.quantity;
    }
    if (address) {
        mixinData.address = address;
        getLatLong(handlePreferredStore, mixinData);
    } else {
        const isCartPage = isInCartPage();
        geolocate(
            data => {
                ispuModalContainer.find('.sheet-dialog').spinner().start();
                getJSON(actionUrl, 'POST', data, handleStoreResults);
            },
            {
                products,
                storeID: storeId,
                isCartPage,
                selectStoreView: isInPdpPage()
            },
            data => {
                getJSON(actionUrl, 'POST', data, handleStoreResults);
            }
        );
    }
});

// Event listener to render pick up in store confirmation template
ispuClosestParent.on('click', '.pick-up-confirm-button', event => {
    const { dataset } = event.target;
    const { actionUrl, storeId } = dataset;
    const isCartPage = isInCartPage();
    const data = {
        storeID: storeId,
        isCartPage
    };
    ispuModalContainer.find('.sheet-dialog').spinner().start();
    getJSON(actionUrl, 'GET', data, handleConfirmStoreResults, errorCallBack);
});

// Event listener to ISPU store confirmation in cart
ispuClosestParent.on('click', '.store-confirm-button', async event => {
    const selectedStoreInput = queryFirst('.select-store-input:checked:not([disabled])');
    if (!selectedStoreInput) return;
    const { target } = event;
    const { actionUrl } = target.dataset;
    const { storeId } = selectedStoreInput.dataset;
    const isEditStore = JSON.parse(ispuContainer.dataset.editStore);
    let reqData;
    if (isEditStore) {
        const productsInfo = JSON.stringify(getIspuCartLineItemDetails());
        reqData = {
            productsInfo,
            storeID: storeId
        };
    } else {
        const { pid, uuid, quantity } = ispuContainer.dataset;
        reqData = {
            pid,
            uuid,
            quantity,
            storeID: storeId
        };
    }
    ispuModalContainer.find('.sheet-dialog').spinner().start();

    try {
        const res = await fetch(actionUrl, {
            method: 'POST',
            body: toFormData(reqData)
        });

        if (!res.ok) throw new Error('response was not OK');
        const data = await res.json();

        if (data.error) {
            const { lineItemErrorMessage } = data;
            ispuModalContainer.find('.sheet-dialog').spinner().stop();
            ispuModalContainer.modal('hide');
            $('.add-to-cart-messages').remove();
            if ($('.add-to-cart-messages').length === 0) {
                $('body').append('<div class="add-to-cart-messages"></div>');
            }
            $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' + lineItemErrorMessage + '</div>');
            setTimeout(function () {
                $('.add-to-basket-alert').remove();
            }, 5000);
        } else {
            const { cartProductsHtml, totals } = data;
            const { discountsHtml } = totals;
            const couponsEl = queryFirst('.coupon-wrapper');

            if (couponsEl && discountsHtml) {
                couponsEl.innerHTML = discountsHtml;
            }
            if (cartProductsHtml) {
                document.cookie = `dwapupreq=${new Date().getTime()}; `;
                updateCartItems(data);
                updatePromoCodeDetails(data.totals.discounts, data.selectedShippingMethod);
                updateCartTotals(data);
                validateBasket(data);
                $('body').trigger('cart:update');
                ispuModalContainer.find('.sheet-dialog').spinner().stop();
                ispuModalContainer.modal('hide');
            }
        }
    } catch (err) {
        console.error(`pickUpInStore error: ${err.message}`);
        ispuModalContainer.find('.sheet-dialog').spinner().stop();
    }
});

// Event listener to toggle store details accordion label
ispuClosestParent.on('click', '.store-locator-container .store-btn-link', event => {
    const { target } = event;
    queryFirst('.collapsed', target).classList.toggle(hiddenClass);
    queryFirst('.expanded', target).classList.toggle(hiddenClass);
});

// Event listener to show stores to select on click of change location on pickup confirmation page
ispuClosestParent.on('click', '.change-location-link', () => {
    addClass(queryFirst('.pick-up-confirm-section'), hiddenClass);
    removeClass(queryAll('.pick-up-in-stores, .find-stores-form'), hiddenClass);
});

// Event listener to remove no stores error message on change of ISPU search input
ispuClosestParent.on('keyup', '.find-store-input', event => {
    const pickupAddToCartBlock = queryFirst('.pickup-in-store-modal .js-sp-add-to-cart');
    queryFirst('.store-locator-no-results', ispuModalContainer[0]).textContent = '';
    queryFirst('.pick-up-in-stores', ispuContainer).innerHTML = '';
    addClass([queryFirst('.geo-location-error', ispuContainer), pickupAddToCartBlock], hiddenClass);
    const findStoreSubmit = queryFirst('.find-store-submit', event.target.closest('.pickup-in-store-container'));
    if (event.target.value) {
        findStoreSubmit.removeAttribute('disabled');
    } else {
        findStoreSubmit.disabled = true;
    }
});

$('.sheet[id*="pick-up-in-store"]').on('hidden.bs.modal', () => {
    const activeIspuModalContainer = ispuModalContainer.filter(':has(.active)');
    const activeIspuContainer = activeIspuModalContainer.find('.sheet-page.pickup-in-store-content .pickup-in-store-container')[0] || ispuContainer;
    const findStore = queryFirst('.find-store-input', activeIspuContainer);
    if (findStore) findStore.value = '';
    removeClass(queryAll('.pickup-in-store-product, .find-stores-form', activeIspuContainer), hiddenClass);
    queryFirst('.pick-up-in-stores', activeIspuContainer).innerHTML = '';
    const noStoresMessage = queryFirst('.store-locator-no-results', activeIspuContainer);
    const confirmSection = queryFirst('.pick-up-confirm-section', activeIspuContainer);
    const geolocateError = queryFirst('.geo-location-error', activeIspuContainer);
    confirmSection.innerHTML = '';
    addClass([confirmSection, noStoresMessage, geolocateError], hiddenClass);
    queryFirst('.find-store-submit', activeIspuContainer).disabled = true;
    if (isInCartPage()) {
        activeIspuContainer.dataset.editStore = 'false';
    }
    // remove any active class from the pickup-in-store-content on closing the modal
    addClass(queryAll('.sheet-page.pickup-in-store-content'), HIDDEN_CLASS);
    removeClass(queryAll('.sheet-page.pickup-in-store-content'), ACTIVE_CLASS);
});

// Event listener to retrieve geo location based store results on click of use current location
ispuClosestParent.on('click', '.detect-location', event => {
    const { actionUrl } = event.currentTarget.dataset;
    const mixinData = { actionUrl, forceGeoLocation: true };
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    queryAll('.find-store-input', queryFirst('.sheet.modal[id*="pick-up-in-store"]')).forEach(input => {
        input.value = '';
    });
    queryFirst('.find-store-submit', ispuContainer).disabled = true;
    geolocate(handleInStore, mixinData, () => {
        removeClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
        addClass([storeResults, noStoresMessage], hiddenClass);
    });
});
